import React, { useState, useEffect } from "react";
import makeStyles from "@mui/styles/makeStyles";

import {
  Grid,
  TextField,
  Button,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Typography,
  Select,
  MenuItem,
  ListItemText,
  Input,
  InputLabel,
} from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Include the Quill styles
import { useTranslation } from "react-i18next";

const EmailSmsTemplateFormData = ({
  errorObject,
  addProductForm,
  formData,
  handleChange,
  handleChangeTextEditor,
  handleCheck,
  handleReset,
  handleSubmit,
  handleUpdate,
  open,
  ...props
}) => {
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage"),
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "email-sms-template-entry";
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const TemplateModeList = JSON.parse(localStorage.getItem("TemplateModeList"));

  const RoleList = JSON.parse(localStorage.getItem("RoleList"));

  /*   const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5 + 8,
        width: 250,
      },
    },
  }; */

  const [selectedRoleIds, setSelectedRoleIds] = useState([]);

  // Pre-select roles if formData already has values
  /*   useEffect(() => {
    if (formData.RoleId) {
      const preSelectedRoles = RoleList.filter(role =>
        formData.RoleId.includes(role.id)
      );
      setSelectedRoles(preSelectedRoles);
    }
  }, [formData.RoleId]); */

  // Pre-select roles if formData already has values
  /*   useEffect(() => {

    console.log("formData.RoleId ",formData.RoleId);
    if (formData.RoleId && Array.isArray(formData.RoleId)) {
    
      setSelectedRoleIds(formData.RoleId); // Assuming formData.RoleId is an array of IDs
    }
  }, [formData.RoleId]);
 */

  useEffect(() => {
    // Check if formData.RoleId is a string and convert it to an array of numbers
    if (typeof formData.RoleId === "string") {
      const roleIdsArray = formData.RoleId.split(",").map((id) =>
        parseInt(id.trim()),
      ); // Convert strings to numbers

      console.log("roleIdsArray ", roleIdsArray);
      setSelectedRoleIds(roleIdsArray);
    } else if (Array.isArray(formData.RoleId)) {
      setSelectedRoleIds(formData.RoleId.map((id) => parseInt(id)));
    }
  }, [formData.RoleId]);

  const handleChangeMultiple = (event) => {
    const {
      target: { value },
    } = event;

    const newSelectedRoleIds = Array.isArray(value)
      ? value.filter((v) => !isNaN(v))
      : [];

    setSelectedRoleIds(newSelectedRoleIds);
    // Update formData with selected role IDs
    props.handleChangeChoosenProps("RoleId", newSelectedRoleIds);
  };

  // Custom toolbar options
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "link"],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ["link"],
      ["clean"],
    ],
  };

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid container>
            <Grid item xs={12} sm={12}>
              <div className="sw_page_heading">
                <div className="sw_heading_title">
                  {DispensingLanguage[lan][menukey]["Template Entry Form"]}
                </div>

                <div className="float-end sw_btn_control">
                  {addProductForm ? (
                    <Grid item xs={12} className="mt-4 text-center">
                      <Button
                        disabled={!!props.permissionType}
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => handleReset()}
                      >
                        {t(DispensingLanguage[lan][menukey]["Reset"])}
                      </Button>
                      <Button
                        disabled={!!props.permissionType}
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => handleSubmit()}
                      >
                        {t(DispensingLanguage[lan][menukey]["Save"])}
                      </Button>
                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() =>
                          props.history.push("/email-sms-template-entry")
                        }
                      >
                        {t(DispensingLanguage[lan][menukey]["Cancel"])}
                      </Button>
                    </Grid>
                  ) : (
                    <Grid item xs={12} className="mt-2 text-center">
                      <Button
                        disabled={!!props.permissionType}
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => handleUpdate()}
                      >
                        {t(DispensingLanguage[lan][menukey]["update"])}
                      </Button>
                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() =>
                          props.history.push("/email-sms-template-entry")
                        }
                      >
                        {t(DispensingLanguage[lan][menukey]["Cancel"])}
                      </Button>
                    </Grid>
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <Grid container className="mb-3">
          <Grid item xs={12} sm={12}>
            {DispensingLanguage[lan][menukey]["You_can_edit_the_mail"] + " :"}
          </Grid>
        </Grid>

        <Card className="sw_card">
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.EventType}
                  helperText={errorObject.EventType}
                  required
                  id="EventType"
                  name="EventType"
                  label={DispensingLanguage[lan][menukey]["Event Type"]}
                  value={formData.EventType}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormControl
                  className={classes.fullWidth}
                  variant="standard"
                  disabled={!!props.permissionType}
                >
                  <InputLabel id="RoleId">
                    {DispensingLanguage[lan][menukey]["Role Name"]}{" "}
                  </InputLabel>
                  <Select
                    labelId="RoleId"
                    id="RoleId"
                    multiple
                    value={selectedRoleIds}
                    onChange={handleChangeMultiple}
                    input={<Input />}
                    renderValue={(selected) =>
                      RoleList.filter((role) => selected.includes(role.id))
                        .map((role) => role.name)
                        .join(", ")
                    }
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 46 * 4.5 + 8,
                          width: 250,
                        },
                      },
                      disableAutoFocusItem: false,
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                    label={DispensingLanguage[lan][menukey]["Role Name"]}
                  >
                    {RoleList.map((role) => (
                      <MenuItem
                        key={role.id}
                        value={role.id}
                        style={{ position: "relative" }}
                      >
                        <Checkbox checked={selectedRoleIds.includes(role.id)} />
                        <ListItemText primary={role.name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  id="Receivers"
                  name="Receivers"
                  label={DispensingLanguage[lan][menukey]["Copy To"]}
                  value={formData.Receivers}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>
              <Grid item xs={12} sm={6} className="marginBottom20">
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  id="copySMSTo"
                  name="copySMSTo"
                  label={DispensingLanguage[lan][menukey]["SMS Copy To"]}
                  value={formData.copySMSTo}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>
              <Grid item xs={12} sm={12} className="marginBottom20">
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.mSubject}
                  helperText={errorObject.mSubject}
                  required
                  id="mSubject"
                  name="mSubject"
                  label={DispensingLanguage[lan][menukey]["Subject"]}
                  value={formData.mSubject}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>

              <Grid item xs={12} sm={12} className="marginBottom20">
                <Grid item xs={12}>
                  <InputLabel
                    id="MSG"
                    style={{ color: errorObject.MSG ? "red" : "initial" }}
                    error={!!errorObject.MSG}
                    helperText={errorObject.MSG}
                    required
                  >
                    {DispensingLanguage[lan][menukey]["Body"]}
                  </InputLabel>
                </Grid>
                <Grid item xs={12}>
                  <ReactQuill
                    theme="snow"
                    name="MSG"
                    value={formData.MSG}
                    onChange={(value) => handleChangeTextEditor(value, "MSG")}
                    placeholder=""
                    modules={modules}
                    style={{
                      //minHeight: "100px",
                      borderBottom: errorObject.MSG
                        ? "2px solid red"
                        : "1px solid #ccc", // Red underline if error exists
                      paddingBottom: "0px", // Add padding for better spacing
                    }}
                  />
                  {/* Error message below the editor */}
                  {errorObject.MSG && (
                    <Typography color="error" variant="caption">
                      {errorObject.MSG}
                    </Typography>
                  )}
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormControl
                  className="sw_radiogroup"
                  component="fieldset"
                  disabled={!!props.permissionType}
                >
                  <RadioGroup
                    row
                    aria-label="TemplateMode"
                    name="TemplateMode"
                    value={String(formData.TemplateMode)}
                    onChange={handleChange}
                  >
                    {TemplateModeList.map((item, index) => {
                      return (
                        <FormControlLabel
                          key={String(item.id)}
                          value={String(item.id)}
                          control={<Radio />}
                          label={DispensingLanguage[lan][menukey][item.name]}
                        ></FormControlLabel>
                      );
                    })}
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={3} className="checkBoxCustom">
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={formData.DryMode || false}
                      onChange={(e) => handleCheck(e)}
                      name="DryMode"
                      value="no"
                      disabled={!!props.permissionType}
                    />
                  }
                  label={DispensingLanguage[lan][menukey]["Dry Mode"]}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default EmailSmsTemplateFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
